import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, Renderer2 } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { LayoutService } from 'src/app/shared/LayoutService';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/services/auth.service';
import { AuthResponse } from 'src/services/auth/auth-response.interface';
import { DatalayerService } from 'src/services/datalayer.service';
import { userProfile } from 'src/utils/authentication/userProfile';
import { LocalStorage } from 'src/utils/local-storage';
import { JwtTokenService } from 'src/services/jwt-token.service';
import { CpsNavigationService } from 'src/services/cps-navigation.service';

@Component({
  selector: 'app-hub-home-page',
  templateUrl: './hub-home-page.component.html',
  styleUrls: ['./hub-home-page.component.scss']
})
export class HubHomePageComponent implements OnInit {

  public userIp$: Observable<string>;
  public loginErrorMessage$: BehaviorSubject<string>;

  public loginForm: FormGroup;
  public isButtonDisabled = false;

  constructor(private renderer: Renderer2,
    private jwtTokenService: JwtTokenService,
    private router: Router,
    private localStorage: LocalStorage,
    private datalayer: DatalayerService, 
    public layout: LayoutService,
    private authService: AuthService,
    private datalayerService: DatalayerService,
    private cpsNav: CpsNavigationService
  ) {
    //this.validate();
  }

  ngOnInit(): void {
    const params = new URLSearchParams(window.location.search);
    const refreshTokenFromUrl = params.get('r');

    if (refreshTokenFromUrl) {
      this.exchangeRefreshToken(refreshTokenFromUrl);
      return;
    }

    const token = this.extractTokenFromUrl();
    if (!token && !environment.mockup) {
      this.redirectToLogin();
      return;
    }

    this.authService.checkToken(token).subscribe({
      next: () => {

        // If we have a valid token we should already have our userprofile set at this point
        // Decode JWT to get user profile
        // const tokenPayload = this.decodeJWT(token);
        // if (tokenPayload?.UserInfo) {
        //   this.localStorage.setUserProfile(tokenPayload.UserInfo);
        // }

        // Delay ensures GTM is initialized
        setTimeout(() => {
          this.datalayer.hubHomePageView();
        }, 100);
        
      },
      error: () => {
        // try to get new token. If successful continue. If that fails redirect to login page.
        this.getRefreshToken(this.localStorage.getUserProfile().refresh_token);
      }
    });
  }

  private exchangeRefreshToken(refreshToken: string): void {
    this.authService.getRefreshToken(refreshToken).subscribe({
      next: res => {
        this.completeLogin(res);
      },
      error: (err: HttpErrorResponse) => {
        console.error('Refresh exchange failed');
        console.error('Status:', err.status);
        console.error('Error body:', err.error);
        console.error('Full error:', err);
        this.redirectToLogin();
      }
    });
  }

    private completeLogin(res: AuthResponse): void {

      this.localStorage.setAccessToken(res.access_token);
      this.localStorage.setRefreshToken(res.refresh_token);

      this.jwtTokenService.setToken(res.access_token);
      const user = this.jwtTokenService.getUserInfo();

      user.access_token = res.access_token;
      user.refresh_token = res.refresh_token;

      this.localStorage.setUserProfile(user);

      window.history.replaceState({}, document.title, '/home');

      this.datalayer.hubHomePageView();
  }

  private decodeJWT(token: string): any {
    try {
        const payload = token.split('.')[1];
        return JSON.parse(atob(payload));
    } catch (e) {
        console.error('Invalid token', e);
        return null;
    }
}

  extractTokenFromUrl(): string | null {
    const params = new URLSearchParams(window.location.search);
    return params.get('token') ?? this.localStorage.getAccessToken();
  }

  get f() {
    return this.loginForm.controls;
  }

  tabUser(): void {
    this.renderer.selectRootElement('#password').focus();
  }

  redirectToLogin(): void {
    this.router.navigate(['login']);
  }

  private getRefreshToken(refreshToken: string) {

    this.authService.getRefreshToken(refreshToken).subscribe({
      next: (res: AuthResponse) => {
        // Successfully refresh token 
        this.localStorage.setAccessToken(res.access_token);
        this.localStorage.setRefreshToken(res.refresh_token);
        let user = new userProfile();

        this.jwtTokenService.setToken(res.access_token);
        user = this.jwtTokenService.getUserInfo();

        user.access_token = res.access_token;
        user.refresh_token = res.refresh_token;

        user.authorities = this.localStorage.getUserProfile().authorities;
        user.active_Subscription = this.localStorage.getUserProfile().active_Subscription;

        this.localStorage.setUserProfile(user); 
      },
      error: err => {
        console.log("Could not fetch valid refresh token: " + err);
        this.redirectToLogin();
      }
    });
  }

  goToCps() {
    this.datalayerService.goToCPSClickTile(environment.CPS2_DOMAIN, "Go To CPS");
    this.cpsNav.goToCps();
  }
}
